import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const ContactsCloser = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: ${Colors.darkBlue};
	opacity: 0.2;
`;

export const CheckedDataWrapper = styled.p`
	cursor: pointer;
	width: fit-content;
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	color: ${Colors.green};
	transition: color 0.3s;
	gap: 10px;

	&:hover {
		color: ${Colors.red};
	}
`;
